module.exports = __webpack_public_path__ + "static/media/fundo_goiania_armadilhaOvos.fb0a9f66.png";